import { DatePipe, JsonPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GlobalService } from 'src/app/_services/global.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { HireCompanyHoverModalComponent } from '../../hire-company-hover-modal/hire-company-hover-modal.component';

@Component({
  selector: 'app-hire-slider-experience-view',
  imports: [MatTooltipModule, HireCompanyHoverModalComponent, JsonPipe],
  templateUrl: './hire-slider-experience-view.component.html',
  styleUrl: './hire-slider-experience-view.component.scss',
})
export class HireSliderExperienceViewComponent implements OnInit, OnChanges {

  @Input() experience: any;
  @Input() highlightexperience: any;
  currentCompanyInformation: any = {};

  constructor(private datePipe: DatePipe, private personSearchService: PersonSearchService) {

  }

  ngOnInit() {
    this.processExperience();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Skip the very first change: ngOnChanges always fires before ngOnInit,
    // so ngOnInit's call to processExperience() already handles it.
    if (changes['experience'] && !changes['experience'].isFirstChange()) {
      this.processExperience();
    }
  }

  private processExperience() {
    console.log('experience', this.experience);
      this.experience = (this.experience || []).map((obj, index) => {

          obj.expsummary = obj.summary;
          obj.index = index;
          obj.formattedExpSummary = GlobalService.getFormattedParagraph({ text: obj.expsummary, viewmode: 'less' });
          return obj;
        });
    const companyObjects = this.experience.map(x => x.company);
    const companyLogoPayload = companyObjects.map(x => {
      if (x.id || x.name) {
        return {
          ...(x.id && { id: x.id }),
          ...(x.name && { name: x.name })
        }
      }
    }).filter(Boolean);

    companyLogoPayload?.length &&
      this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
        if (res && res.status == "success") {
          const resultName = res.data
          resultName.forEach(obj => {
            const matchingObj = this.experience.filter((item) => {
              return (obj.searchedVia === 'id' && obj.key === item.company.id) || ((obj.searchedVia === 'name') && (obj.key === item.company.name))
            });
            if (matchingObj && matchingObj.length) {
              let companyLogo = obj.companylogo
              matchingObj.forEach(x => {
                x.companylogo = companyLogo;
              })

            }
          });

        }
      })
  }


  highlightInfo(data: string, type: 'past_jobtitle' | 'location' | 'skill' | 'exp_summary' | 'currentjobtitle' | 'summary' | 'currentcompany' | 'pastcompany' | 'certification', extaInfo = null) {

    if (data || (type === 'exp_summary' && extaInfo?.dataObj)) {
      const dataForHighlight = data ? data.trim().toLowerCase().replace(/<.*?>/g, '').replace(/'/g, "") : '';

      let highlightedData = data;
      switch (type) {

        case 'past_jobtitle':
          {
            if (this.highlightexperience && this.highlightexperience['experience.title.name']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['experience.title.name.keyword']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['job_title.keyword']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['job_title']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'location':
          {
            if (this.highlightexperience && this.highlightexperience['location_name']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['location_locality']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['location_name.keyword']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;

        case 'exp_summary':
          {
            let finalObj;
            if (extaInfo?.action == 'exp_summary' && extaInfo.dataObj) {
              if (this.highlightexperience && this.highlightexperience['experience.summary']) {
                const viewMode = extaInfo?.dataObj?.isTruncated ? 'less' : 'all'

                let highlightFound = this.highlightexperience['experience.summary'].find((summary: string) => {
                  let formatdata = extaInfo.dataObj.data.join(' ').replace(/<.*?>/g, '').trim().toLowerCase();
                  const tempData = GlobalService.getFormattedParagraph({ text: summary.replace(/<.*?>/g, '').trim().toLowerCase(), viewmode: viewMode });
                  if (tempData.data.join(' ') == formatdata) {
                    return true;
                  }
                });

                finalObj = highlightFound ? GlobalService.getFormattedParagraph({ text: highlightFound, viewmode: viewMode })
                  : extaInfo.dataObj;
              } else {
                finalObj = extaInfo.dataObj;
              }
            } else {
              finalObj = extaInfo.dataObj;
            }

            // Defensive fallback: if formattedExpSummary is missing/malformed, fall back to raw text
            if (!finalObj || !Array.isArray(finalObj.data) || finalObj.data.length === 0) {
              highlightedData = data || '';
              break;
            }

            if (finalObj.data.length <= 1) {
              highlightedData = finalObj.data[0];
            } else {
              highlightedData = "";
              finalObj?.data.forEach(item => {
                highlightedData += `<li>${item}</li>`
              })
              highlightedData = `<ul> ${highlightedData} </ul>`;
            }
          }
          break;

        case 'pastcompany':
          {
            if (this.highlightexperience && this.highlightexperience['job_company_name']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['job_company_name.keyword']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['experience.company.name']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['experience.company.name.keyword']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.highlightexperience && this.highlightexperience['lastjob_company_name.keyword']) {
              const highlightFound = this.highlightexperience && this.highlightexperience['lastjob_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').replace(/'/g, "").trim().toLowerCase() === dataForHighlight.replace(/'/g, ""));
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;

      }

      return highlightedData;
      //  }
    }

    return data;
  }

  formatDate(dateString: string): string {
    if (dateString == null || dateString == 'null') {
      return '';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If the date is not valid, or it's just a year (e.g., "2014")
      // then we return it as it is.
      return dateString;
    } else if (dateString && dateString.length === 4) {
      // If the date string contains only the year (e.g., "2014"),
      // we format it as "YYYY" (e.g., "2014")
      return this.datePipe.transform(date, 'yyyy');
    } else {
      // If it's a full date, we format it as "MMMM yyyy" (e.g., "January 2014")
      return this.datePipe.transform(date, 'MMMM yyyy');
    }

  }

  /**
* Used to format data in view-more and view-less form
* @param type i.e. view-more or view-less
* @param obj  data object
*/
  formatDescription(type: string, obj) {
    if (type == 'view-more') {
      this.experience.forEach(item => {
        if (item.index == obj.index) {
          item.formattedExpSummary = GlobalService.getFormattedParagraph({ text: obj.expsummary, viewmode: 'all' });
        }
      })

    } else if (type == 'view-less') {
      this.experience.forEach(item => {
        if (item.index == obj.index) {
          item.formattedExpSummary = GlobalService.getFormattedParagraph({ text: obj.expsummary, viewmode: 'less' });
        }
      })
    }
  }

  getCompanyInfo(type: string, data: any, event) {
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    // this.currentCompanyInformation = {}
    let companyData = [];
    let pastCompanyData = data?.company
    if (!pastCompanyData?.website) {
      return;
    }

    if (type == 'past') {

      companyData.push(
        {
          ...(pastCompanyData?.id && { id: pastCompanyData?.id }),
          ...(pastCompanyData?.name && { name: pastCompanyData?.name })
        }
      )
    }

    companyData?.length && this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if (res.status == 'success' && res.data) {
        let companyDetails = res.data[0]
        if (type == 'past') {
          this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData.name
          this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
          this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location
          this.currentCompanyInformation['size'] = companyDetails.size ? companyDetails.size : pastCompanyData?.size
          this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url ? companyDetails.linkedin_url : pastCompanyData.linkedin_url
          this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website
          this.currentCompanyInformation['facebook_url'] = companyDetails.facebook_url ? companyDetails.facebook_url : pastCompanyData.facebook_url
          this.currentCompanyInformation['twitter_url'] = companyDetails.twitter_url ? companyDetails.twitter_url : pastCompanyData.twitter_url
        }
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = companyDetails.id


        //loadn[0].style.display = 'block'
      }
    });


  }

   openUrl(link, type) {
    if (type == 'website') {
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }


}
